<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <company-public-info ></company-public-info>
        <div class="card">
        
            <div class="card-header ">
                <div class="float-left align-self-center pt-1 col-sm-2" style="font-size: 18px;">Total Employee <span class="ml-2" style="color: #5A8DEE;">{{people}}</span></div>
                <div class="float-left align-self-center col-sm-4 custom-search">
                    <b-input-group >
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search by employee / position / branch / email / phone" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
                <div class="float-right col-sm-6 text-right" >
                    <b-button  class="" @click="massUpdate">Bulk Changes</b-button>                    
                    <b-button  class="employee-filter-btn" v-b-toggle.sidebar_right>Filter<b-icon class="ml-3" icon="funnel-fill" ></b-icon></b-button>
                </div>
            </div>                    
            
            <div class="card-body container">       
                <div class="list-view" >
                    <div class="row border-bottom  py-2">
                        <div class="col-sm-4 text-uppercase py-1 font-weight-bold row pl-0 ml-0">                    
                            <input type="checkbox" v-model="selectAll" class="ml-1 mr-4">
                            Employee
                        </div>
                        <div class="col-sm-3 text-uppercase py-1 font-weight-bold ">
                            Contact Details
                        </div>
                        <div class="col-sm-4 text-uppercase py-1 font-weight-bold pl-1">
                            Personal File
                        </div>                
                    </div>

                    <div class="row border-bottom py-2" v-for="employee in paginatedData" :key="employee.employee_id">
                        
                        <div class="col-sm-4 justify-content-center row pl-0 ml-0">
                            <div class="col-sm-1 pl-1 justify-content-center">
                                <input type="checkbox" class="justify-content-center" v-model="selected" :value="employee.employee_id" number>
                            </div>
                            <div class="col-sm-4 px-0 cursor-pointer" @click="editEmployee(employee.employee_id , 0)">                        
                                <img v-if="employee.pic != ''" v-bind:src="$api_url+'/avatar/'+ employee.company_id + '/' + employee.pic" class="img-fluid img-thumbnail" />
                                <img v-else v-bind:src="$api_url+'/avatar/demo.jpg'" class="img-fluid img-thumbnail" />
                            </div>
                            <div class="col-sm-7">
                                <div class="text-uppercase py-1 font-weight-bold cursor-pointer" @click="editEmployee(employee.employee_id , 0)">{{employee.name}}</div>
                                <div>
                                    {{employee.jobposition}}<br />
                                    {{employee.department}}                        
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3 ">
                            {{employee.email}}<br />
                            {{employee.phone}}<br />
                            {{employee.employee_code}}
                        </div>
                        
                        <div class="col-sm-5 px-0">
                            <b-button-group class="row">
                                <b-button variant="outline-secondary" title="Edit" v-if="ce" @click="editEmployee(employee.employee_id , 0)">Info</b-button>
                                <b-button variant="outline-secondary" title="Contract" v-if="ce" @click="editEmployee(employee.employee_id , 1)">Contract</b-button>
                                <b-button variant="outline-secondary" title="Pay Slip" @click="editEmployee(employee.employee_id , 4)">Pay Slips</b-button>
                                <b-button variant="outline-secondary" title="Tax Card" v-if="ce" @click="editEmployee(employee.employee_id , 3)">Tax Cards</b-button>
                                <b-button variant="outline-secondary" title="Investment" v-if="ce" @click="editEmployee(employee.employee_id , 2)">Investment</b-button>
                                
                                <!--<b-button variant="outline-secondary" title="Challan" v-if="ce" @click="editEmployee(employee.employee_id , 5)">Challan</b-button>-->
                            </b-button-group>
                            <!--<b-button-group class="row mt-2">
                                <b-button variant="outline-secondary" title="PF Contribution" @click="editEmployee(employee.employee_id , 5)">PF Contribution</b-button>
                                <b-button variant="outline-secondary" title="Leave & Attendance" v-if="ce" @click="editEmployee(employee.employee_id , 6)">Leave & Attendance</b-button>
                            </b-button-group>-->
                        </div>
                    </div>
                </div>

                <div class="row p-2 float-right" v-if="paginatedData.length > 0">
                    <div class="row p-2 float-right" v-if="paginatedData.length > 0">                
                        <ul class="pagination b-pagination">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="length" :options="length_options"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right" v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
                
                </div>
                <div class="row p-2" v-if="paginatedData.length == 0">
                    {{blankmsg}}
                </div>
            </div>

            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <template v-slot:default="{ hide }">
                    <div class="px-3 py-2">
                    
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="person-fill"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Name.." v-model="search_group.name" @input="setSearch()"></b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="envelope"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="email" placeholder="eMail.." v-model="search_group.email" @input="setSearch()"></b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="phone"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Mobile Number.." v-model="search_group.phone" @input="setSearch()"></b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="list"></b-icon>
                            </b-input-group-prepend>
                            
                            <select name="department_id" class='form-control' v-model='search_by_id.department_id' @change="setSearch()">
                                <option value='0' >Select Department</option>
                                <option v-for='data in depertments' :value='data.id'>{{ data.name }}</option>
                            </select>
                        </b-input-group>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="list-ul"></b-icon>
                            </b-input-group-prepend>
                            
                            <select name="jobposition_id" class='form-control' v-model='search_by_id.jobposition_id' @change="setSearch()">
                                <option value='0' >Select Job Type</option>
                                <option v-for='data in jobtypes' :value='data.id'>{{ data.name }}</option>
                            </select>
                        </b-input-group>

                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="house"></b-icon>
                            </b-input-group-prepend>
                            
                            <select name="branch_id" class='form-control' v-model='search_by_id.branch_id' @change="setSearch()">
                                <option value='0' >Select Branch</option>
                                <option v-for='data in branches' :value='data.id'>{{ data.name }}</option>
                            </select>
                        </b-input-group>

                        <div class="mt-4" >
                            <b-button variant="outline-secondary" block  title="Clear Filter" @click="resetFlter();"><div block @click="hide">Clear Filter</div></b-button>
                        </div>
                    </div>
                </template>
            </b-sidebar>
        </div>
    </b-overlay>
</template>


<script>
    export default{      
        
        data(){
            return {
                
                cu:window.location.href,
                ce:false,
                employees : [],                
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search_group:{name:'', email:'', phone:'' },
                search_by_id:{department_id:0, jobposition_id:0 , branch_id:0},
                
                selected: [],
                showoverlay : true,
                notice: "Looks like you have not setup any employees yet. Setup your first employee.",
                blankmsg : 'Fetching data..',
                people:0,

                fdata: {
                            residency:null , 
                            gender:null , 
                            marital_status:null , 
                            department_id:0 , 
                            jobposition_id:0, 
                            branch_id:0,
                            manager_id:0,
                        },

                residency: [
                    { value: null, text: "Select..." },
                    { value: "Resident", text: "Resident" },
                    { value: "Non Resident", text: "Non Resident" }
                ],
                gender:[
                    { value: null, text: "Select..." },
                    { value: "Male", text: "Male" },
                    { value: "Female", text: "Female" },
                    { value: "Other", text: "Other" },
                ],
                marital_status:[
                    { value: null, text: "Select..." },
                    { value: "Single", text: "Single" },
                    { value: "Married", text: "Married" },
                    { value: "Widower", text: "Widower" },
                    { value: "Divorced", text: "Divorced" },
                ],

                depertments:[],
                jobtypes:[],
                branches:[],
                manager:[],

                search:'',
                length: 20,
                length_options: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
            }
        },
        methods:{            

            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },
            resetFlter: function()
            { 
                this.search_group.name = '';
                this.search_group.email = '';
                this.search_group.phone = '';
                this.search_by_id.department_id = 0;
                this.search_by_id.jobposition_id = 0;
                this.search_by_id.branch_id = 0;
                this.jobtypes = [];
                this.getEmployees();
            },
            setSearch: function(pageflg)
            {
                this.pagination.currentPage = 1;
                this.getEmployees();
            },
            setPagination: function(pageflg)
            {                
                if(pageflg)
                    this.pagination.currentPage = this.pagination.nextPage;
                else    
                    this.pagination.currentPage = this.pagination.prevPage;
                
                this.getEmployees();
            },
            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;

                axios.get(this.$api_url+'/employee/list' , {
                    params: {
                        page: this.pagination.currentPage,
                        //per_page: this.per_page,
                        search_query: this.search_group,
                        search_query_by_id: this.search_by_id,
                    }
                    }).then(function(response){
                        
                        this.showoverlay = false;
                        if(response.data.error == 1)
                            this.notice = response.data.notice;
                        else
                        {
                            this.employees = response.data;

                            if(this.employees.length == 0)
                                this.blankmsg = "Looks like you have not setup any employees yet. Setup your first employee.";
                            else
                            {
                                this.length_options = [{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" }, 
                                                    { value: this.employees.length, text: "All" }
                                                ]; 
                                this.people = this.employees.length;
                            }
                                
                        }

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            getDepertments: function(){
              axios.get(this.$api_url+'/department/list')
              .then(function (response) {
                 this.depertments = response.data;
              }.bind(this));
         
            },
            getJobTypes: function() {
                axios.get(this.$api_url+'/jobposition/options',{
                 params: {
                   
                 }
              }).then(function(response){
                    this.jobtypes = response.data;
                }.bind(this));
            },
            getJobTypesMassUpdate: function() {
                axios.get(this.$api_url+'/jobposition/options',{
                 params: {
                   //y: this.fdata.department_id
                 }
              }).then(function(response){                    
                    this.jobtypes = response.data;
                    this.fdata.jobposition_id = 0;
                }.bind(this));
            },
            getBranches: function(){
              axios.get(this.$api_url+'/branch/list')
              .then(function (response) {
                 this.branches = response.data;
              }.bind(this));
         
            },

            getManagers: function(){
              axios.get(this.$api_url+'/manager')
              .then(function (response) {                     
                    this.manager = [{ value: 0, text: "Select..." } ] . concat(response.data);
              }.bind(this));
         
            },
            editEmployee:function(x , i)
            {    
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response) 
                    {    
                        this.showoverlay = false;
                        if(i == 6)
                            window.location.href = this.$api_url+'/attendances';
                        else if(i > 0)
                            window.location.href = this.$api_url+'/employee/info?#=' + i;
                        else
                            window.location.href = this.$api_url+'/employee/info';
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },            
            massUpdate: function()
            {
                if(this.selected == '')
                    alert('No employee selected');
                else
                {
                    alert(this.selected);
                    //this.$bvModal.show('bv-modal-massupdate');

                }

            },
            onSubmitMassUpdate(e) 
            {
                if(!this.checkNet()) return false;

                if((this.fdata.department_id > 0) && (this.fdata.jobposition_id == 0))
                {
                    alert('Select Job Position for changed Department');

                }
                else
                {

                    
                }
                
            },            
        },
        created: function(){
            this.getAcl();            
            this.getDepertments();
            this.getJobTypes();
            this.getBranches();
            //this.getManagers();
            this.getEmployees();
            Fire.$on('reloadUsers', () => {this.getEmployees()})
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.employees;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                       
                }

                this.people = filtered_list.length;
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            selectAll: {
                get: function () {
                    return this.employees ? this.selected.length == this.employees.length : false;
                },
                set: function (value) {
                    var selected = [];
                    if (value) {
                        this.employees.forEach(function (user) {
                            selected.push(user.employee_id);
                        });
                    } 
                    this.selected = selected;
                }
            }
        }
    }
</script>
<style>
button.disabled{
    cursor: default;
}

</style>
